<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '28rem' }"
  [contentStyle]="{ padding: '0' }"
  styleClass="link-list-dialog"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="flex flex-col gap-0.5">
      <h2 class="text-body-lg-500 text-surface-900 m-0">{{ header() }}</h2>
      <span class="text-body-sm text-surface-500">
        {{ items().length }} {{ items().length === 1 ? 'image' : 'images' }}
      </span>
    </div>
  </ng-template>

  <div class="relative flex flex-col gap-2 p-4 pt-0">
    <p-listbox
      [options]="items()"
      optionLabel="id"
      [emptyMessage]="emptyMessage()"
      styleClass="w-full shadow-none border-surface-300"
      listStyleClass="!p-2 flex flex-col gap-1 max-h-96 overflow-y-auto"
      (onClick)="onItemClick($event)"
    >
      <ng-template #item let-item let-i="index">
        <div class="flex d-flex flex-col w-full w-100">
          <div class="flex d-flex items-center justify-between w-full w-100 gap-1 px-3 py-2.5">
            <span class="flex items-center gap-2 text-body-sm-500 text-primary-600">
              <i class="pi pi-image text-surface-400"></i>
              Image {{ i + 1 }}
            </span>
            <span class="text-primary text-sm cursor-pointer flex items-center gap-1 ms-auto">
              <i class="pi pi-eye text-sm"></i>
              View
            </span>
            <!-- <i class="pi pi-chevron-right text-surface-300 text-xs"></i> -->
          </div>
        </div>
      </ng-template>
    </p-listbox>
  </div>
</p-dialog>
